import React from 'react';

const UseCaseMMC: React.FC = () => {
  return (
    <div className="uc-section-dark">
      <div className="uc-inner">
        <div className="uc-label"><span>Multi-Market Comparison</span></div>
        <h2 className="uc-title">Your obvious choice<br /><em>might not be the right one.</em></h2>
        <p className="uc-sub">Every simulation automatically compares your target against similar markets. Here's what that looks like — you submit Germany, we find what actually performs best.</p>
        <div style={{ maxWidth: '620px', margin: '0 auto 16px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', padding: '28px 24px', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(90deg, var(--sage), var(--gold))', borderRadius: '16px 16px 0 0' }}></div>
          <div style={{ marginBottom: '16px' }}>
            <span style={{ fontFamily: "'Libre Baskerville',serif", fontSize: '13px', fontWeight: 700, color: 'var(--white)' }}>Germany vs. Alternatives</span>
          </div>
          <table className="mmc-table">
            <thead>
              <tr><th>#</th><th>Market</th><th>Score</th><th>Profitable</th><th>12-Mo Rev</th><th>Verdict</th></tr>
            </thead>
            <tbody>
              <tr className="mmc-winner">
                <td>1</td>
                <td>🇳🇱 Netherlands <span className="mmc-tag go" style={{ marginLeft: '4px', fontSize: '7px', verticalAlign: 'middle' }}>Recommended</span></td>
                <td><div className="mmc-score"><span>8.4</span><div className="mmc-score-bar"><div className="mmc-score-fill high" style={{ width: '84%' }}></div></div></div></td>
                <td>Month 7</td><td>€412K</td>
                <td><span className="mmc-tag go">Strong GO</span></td>
              </tr>
              <tr>
                <td>2</td><td>🇩🇰 Denmark</td>
                <td><div className="mmc-score"><span>7.8</span><div className="mmc-score-bar"><div className="mmc-score-fill high" style={{ width: '78%' }}></div></div></div></td>
                <td>Month 8</td><td>€298K</td>
                <td><span className="mmc-tag go">GO</span></td>
              </tr>
              <tr>
                <td>3</td><td>🇩🇪 Germany</td>
                <td><div className="mmc-score"><span>7.0</span><div className="mmc-score-bar"><div className="mmc-score-fill mid" style={{ width: '70%' }}></div></div></div></td>
                <td>Month 10</td><td>€353K</td>
                <td><span className="mmc-tag caution">Conditional</span></td>
              </tr>
              <tr>
                <td>4</td><td>🇵🇱 Poland</td>
                <td><div className="mmc-score"><span>6.5</span><div className="mmc-score-bar"><div className="mmc-score-fill mid" style={{ width: '65%' }}></div></div></div></td>
                <td>Month 11</td><td>€215K</td>
                <td><span className="mmc-tag caution">Conditional</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <p style={{ textAlign: 'center', fontSize: '13px', color: 'rgba(255,255,255,0.4)', maxWidth: '560px', margin: '0 auto' }}>
          Netherlands reaches profitability 3 months earlier than Germany, at a lower cost to enter.
        </p>
      </div>
    </div>
  );
};

export default UseCaseMMC;
